const SHOPIFY_DEFAULT_VARIANT_NAME = "Default Title";

export function isMeaningfulVariantName(
  name: string | null | undefined,
): boolean {
  return !!name?.trim() && name.trim() !== SHOPIFY_DEFAULT_VARIANT_NAME;
}

export function formatVariantLabel(
  name: string | null | undefined,
): string | null {
  return isMeaningfulVariantName(name) ? name!.trim() : null;
}
